export const getTokenData = (state) => state.auth.tokenData;
export const getUsername = (state) => state.auth.username;
export const getAvatar = (state) => state.auth.avatar;
